/* Feature Accordion — assets/feature-accordion.js (jQuery)
   Loads jQuery automatically if the theme doesn't already include it. */
(function () {
  function init($) {
    var SPEED = 300;

    function setup($root) {
      if ($root.data('faInit')) return;
      $root.data('faInit', true);

      var single = $root.data('single') === true || $root.data('single') === 'true';

      // Make sure items that start open are visible
      $root.find('.fa__item.is-open .fa__panel').show();

      $root.on('click', '.fa__trigger', function () {
        var $item = $(this).closest('.fa__item');
        var $panel = $item.children('.fa__panel');
        var isOpen = $item.hasClass('is-open');

        if (single && !isOpen) {
          $root.find('.fa__item.is-open').not($item).each(function () {
            close($(this));
          });
        }

        if (isOpen) close($item);
        else open($item);
      });

      function open($item) {
        $item.addClass('is-open');
        $item.children('.fa__trigger').attr('aria-expanded', 'true');
        $item.children('.fa__panel').stop(true, true).hide().slideDown(SPEED);
      }
      function close($item) {
        $item.children('.fa__trigger').attr('aria-expanded', 'false');
        $item.children('.fa__panel').stop(true, true).slideUp(SPEED, function () {
          $item.removeClass('is-open');
        });
      }

      // Open item from URL hash, e.g. /products/x#fa-design
      if (window.location.hash) {
        var $target = $root.find(window.location.hash.replace(/[^#\w-]/g, ''));
        if ($target.length && $target.hasClass('fa__item') && !$target.hasClass('is-open')) {
          $target.find('.fa__trigger').trigger('click');
        }
      }
    }

    $(function () {
      $('[data-fa]').each(function () { setup($(this)); });
    });

    // Theme editor support
    $(document).on('shopify:section:load', function (e) {
      $(e.target).find('[data-fa]').each(function () { setup($(this)); });
    });
    $(document).on('shopify:block:select', function (e) {
      var $item = $(e.target).closest('.fa__item');
      if ($item.length && !$item.hasClass('is-open')) $item.find('.fa__trigger').trigger('click');
    });
  }

  if (window.jQuery) {
    init(window.jQuery);
  } else {
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js';
    s.onload = function () { init(window.jQuery); };
    document.head.appendChild(s);
  }
})();